export default "__VITE_ASSET__B4tWxS1Q__"